import { CircularProgress } from "@material-ui/core";
import React from "react";
import Table from "react-bootstrap/Table";

const TotalDonor = ({
  className,
  widgetHeight = "450px",
  title = "",
  data = [],
  loading = false,
  tableHeader = []
}) => {
  return (
    <>
      <div
        className={`card card-custom overflow-auto ${className}`}
        style={{ height: widgetHeight, fontSize: '10px' }}
      >
        <div
          className={`card-body ${loading &&
            "d-flex justify-content-center"} text-center`}
        >
          {loading ? (
            <div className="text-center align-self-center">
              <CircularProgress color="inherit" />
            </div>
          ) : (
            <div className="d-flex justify-content-center align-content-center">
              <div className="align-self-center">
                <p className="text-hover-primary text-center font-weight-bold font-size-h6">
                  {title}
                </p>
                <div className="overflow-auto">
                  <Table className="overflow-auto table-head-custom-font-size">
                    <thead>
                      <tr>
                        <th className="text-left">No</th>
                        {tableHeader.map(({ classes = "", label }) => (
                          <th className={classes}>{label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => {
                        return (
                          <tr>
                            <td className="text-left">{Number(index) + 1}</td>
                            <td className="text-left">{item.name}</td>
                            <td className="text-center">
                              {item.total_donor}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TotalDonor;
